export enum WarehouseReleaseListItemAction {
  Approve,
  Edit,
  More,
  Preview,
  Remove,
}
